import { render, staticRenderFns } from "./DraggablePopup.vue?vue&type=template&id=77146c3a&scoped=true&"
import script from "./DraggablePopup.vue?vue&type=script&lang=js&"
export * from "./DraggablePopup.vue?vue&type=script&lang=js&"
import style0 from "./DraggablePopup.vue?vue&type=style&index=0&id=77146c3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77146c3a",
  null
  
)

export default component.exports